// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { APIProvider } from '@vis.gl/react-google-maps';
import { trackPageView } from './utils/gtm';
import PageWrapper from './components/PageWrapper';
import Home from './pages/Home';
import Resources from './pages/Resources';
import Services from './pages/Services';
import Contact from './pages/Contact';
import About from './pages/About';
import NeurologicalTesting from './pages/NeurologicalTesting';
import KetamineTreatment from './pages/KetamineTreatment';
import TMSTherapy from './pages/TMSTherapy';
import MedicationManagement from './pages/MedicationManagement';
import ValantNewPatientForm from './pages/ValantNewPatientForm';
import Pamphlets from './pages/Pamphlets';
import Team from './pages/Team';
import MarketingRedirect from './pages/MarketingRedirect';
import MedicationRefill from './pages/MedicationRefill';
import PrivacyPolicy from './pages/PrivacyPolicy';
import FormAccepted from './pages/FormAccepted';
import NotFound from './pages/NotFound';

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageWrapper><Home /></PageWrapper>} />
        <Route path="/resources" element={<PageWrapper><Resources /></PageWrapper>} />
        <Route path="/services" element={<PageWrapper><Services /></PageWrapper>} />
        <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} />
        <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
        <Route path="/adhd-testing" element={<PageWrapper><NeurologicalTesting /></PageWrapper>} />
        <Route path="/ketamine" element={<PageWrapper><KetamineTreatment /></PageWrapper>} />
        <Route path="/tms" element={<PageWrapper><TMSTherapy /></PageWrapper>} />
        <Route path="/med-management" element={<PageWrapper><MedicationManagement /></PageWrapper>} />
        <Route path="/newpatients" element={<PageWrapper><ValantNewPatientForm /></PageWrapper>} />
        <Route path="/pamphlets" element={<PageWrapper><Pamphlets /></PageWrapper>} />
        <Route path="/provider-biographies" element={<PageWrapper><Team /></PageWrapper>} />
        <Route path="/medication-refill" element={<PageWrapper><MedicationRefill /></PageWrapper>} />
        <Route path="/privacy-policy" element={<PageWrapper><PrivacyPolicy /></PageWrapper>} />
        <Route path="/formaccepted" element={<PageWrapper><FormAccepted /></PageWrapper>} />
        <Route path="/marketingmaterials/:uniqueCode" element={<MarketingRedirect />} />
        {/* 404 catch-all route */}
        <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
      </Routes>
    </AnimatePresence>
  );
};

// Component to track page views
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    trackPageView(window.location.href);
  }, [location]);

  return null;
}

function App() {
  return (
    <APIProvider
      apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      onLoad={() => console.log('Google Maps API has loaded.')}
    >
      <Router>
        <PageViewTracker />
        <AnimatedRoutes />
      </Router>
    </APIProvider>
  );
}

export default App;
